// category — am. Canonical bazaar category display names.
// The KEY is the canonical English filter key stored in the database; the
// VALUE is what users read. Never translate the keys — products are matched
// against them.

export default {
  catHandmadeCrafts: 'በእጅ የተሠሩ ሥራዎች',
  catFashion: 'ልብስ',
  catFoodBeverage: 'ምግብ እና መጠጥ',
  catBeautyHealth: 'ውጤትና ጤና',
  catHomeLiving: 'ቤትና የቤት አካባቢ',
  catSportsOutdoors: 'ስፖርትና ውጭ አካባቢ',
  catBooksMedia: 'መጽሐፍና ሚዲያ',
  catServices: 'አገልግሎቶች',
};